'use client';

import { usePathname } from 'next/navigation';
import Icon from '@/components/ui/AppIcon';

interface HeaderProps {
  onSearchOpen?: () => void;
  onNotificationsOpen?: () => void;
  onMenuClick?: () => void;
}

const Header = ({ onMenuClick }: HeaderProps) => {
  const pathname = usePathname();
  const isWhiteBar = pathname?.includes('client-enrollment');

  return (
    <header className="sticky top-0 z-40" style={{ backgroundColor: isWhiteBar ? '#ffffff' : '#eeeced' }}>
      <div className="flex items-center justify-between h-16 pl-4 md:pl-6 lg:pl-[50px] pr-4 md:pr-6 lg:pr-[48px]" style={{ boxSizing: 'border-box' }}>
        <div className="flex items-center gap-4">
          <button
            type="button"
            className="lg:hidden p-2 rounded-md hover:bg-black/5 transition-colors"
            aria-label="Open menu"
            onClick={onMenuClick}
          >
            <Icon name="Bars3Icon" size={24} className="text-foreground" />
          </button>
        </div>
      </div>
    </header>
  );
};

export default Header;